import { ShieldOff } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GlassCard, GlassButton, GradientText } from '../ui/index.js';

export function ForbiddenPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[#0f0f23] p-6">
      <GlassCard padding="lg" className="max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-red-500/10">
            <ShieldOff className="h-8 w-8 text-red-400" />
          </div>
        </div>
        <h1 className="text-2xl font-bold">
          <GradientText>Access Denied</GradientText>
        </h1>
        <p className="mt-3 text-sm text-white/40">
          You don't have permission to access this page. Contact your organization
          administrator if you believe this is an error.
        </p>
        <div className="mt-6">
          <Link to="/">
            <GlassButton variant="primary">Back to Dashboard</GlassButton>
          </Link>
        </div>
      </GlassCard>
    </div>
  );
}
